import React from 'react';

const PageHeader = ({
  pageKey,
  children, // For custom action buttons
  className = ""
}) => {
  // Page configuration with titles, subtitles, and breadcrumb paths
  const pageConfig = {
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Overview of your practice performance and recent activity',
      breadcrumb: ['Home', 'Dashboard']
    },
    calendar: {
      title: 'Master Calendar',
      subtitle: 'Manage appointments and schedules across all practitioners',
      breadcrumb: ['Home', 'Calendar']
    },
    bookings: {
      title: 'All Bookings',
      subtitle: 'View and manage all appointment bookings',
      breadcrumb: ['Home', 'Bookings']
    },
    customers: {
      title: 'Customer Database',
      subtitle: 'Manage your customer database and view booking history',
      breadcrumb: ['Home', 'Customers']
    },
    practitioners: {
      title: 'Practitioners',
      subtitle: 'Manage practitioner profiles, schedules, and onboarding',
      breadcrumb: ['Home', 'Practice', 'Practitioners']
    },
    locations: {
      title: 'Locations',
      subtitle: 'Manage your clinic locations and facilities',
      breadcrumb: ['Home', 'Practice', 'Locations']
    },
    services: {
      title: 'Services',
      subtitle: 'Manage your healthcare services, pricing, and availability',
      breadcrumb: ['Home', 'Practice', 'Services']
    },
    widgets: {
      title: 'Widget Manager',
      subtitle: 'Manage and deploy booking widgets across your platforms',
      breadcrumb: ['Home', 'Digital', 'Widgets']
    },
    integrations: {
      title: 'Integrations',
      subtitle: 'Manage third-party integrations and API connections',
      breadcrumb: ['Home', 'Digital', 'Integrations']
    },
    users: {
      title: 'User Management',
      subtitle: 'Manage user accounts and practitioner associations',
      breadcrumb: ['Home', 'System', 'Users']
    },
    roles: {
      title: 'Roles & Permissions',
      subtitle: 'Manage role-based access control for your healthcare platform',
      breadcrumb: ['Home', 'System', 'Roles']
    },
    settings: {
      title: 'Settings',
      subtitle: 'Configure your practice operations, compliance, and business rules',
      breadcrumb: ['Home', 'System', 'Settings']
    }
  };

  const config = pageConfig[pageKey] || pageConfig.dashboard;

  // Handle breadcrumb navigation
  const handleBreadcrumbClick = (item, index) => {
    // TODO: implement breadcrumb routing
  };

  const renderBreadcrumb = () => {
    return (
      <div className="breadcrumb">
        {config.breadcrumb.map((item, index) => (
          <React.Fragment key={item}>
            {index === config.breadcrumb.length - 1 ? (
              <span className="breadcrumb-current">{item}</span>
            ) : (
              <>
                <a
                  href="#"
                  className="breadcrumb-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleBreadcrumbClick(item, index);
                  }}
                >
                  {item}
                </a>
                <span className="breadcrumb-separator">›</span>
              </>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className={`page-header ${className}`}>
      <div className="header-actions">
        {children}
      </div>

      {renderBreadcrumb()}

      <h1 className="page-title">{config.title}</h1>
      <p className="page-subtitle">{config.subtitle}</p>
    </div>
  );
};

export default PageHeader;